import styled from 'styled-components'

export const Column = styled.div`
    width : 65%;
    margin-left: 17.5%;
    display: flex;
    flex-direction: column;
    padding: 40px 0;
    gap: 1.2rem;
    font-size : 1.1rem;
    font-weight: 500;
`
